var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/czech-republic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/czech-republic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "czech-republic",
    transform: "translate(0.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 256.499025,
    cy: 255.500975,
    r: 255.500975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.281419,255.500975 C234.281419,255.500975 75.9815984,436.203041 75.8318908,436.167111 C122.067587,482.403805 185.943828,511.001949 256.499025,511.001949 C397.607423,511.001949 512,396.609372 512,255.500975 L234.281419,255.500975 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8318908,74.8338402 C-23.9472281,174.612959 -23.9472281,336.387992 75.8318908,436.168109 C117.064359,394.935641 156.719906,355.280094 256.499025,255.500975 L75.8318908,74.8338402 Z",
    id: "Path",
    fill: "#0052B4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/CZ.1b7dab2c62efecd6485f183267994891.svg";
export { ForwardRef as ReactComponent };